import { GENERAL_INSTANCE } from "../constants";
export const MockCoreFuncInstance = GENERAL_INSTANCE;
export const MockERC20FuncInstance = GENERAL_INSTANCE;
export const MockExchangeFuncInstance = GENERAL_INSTANCE;
export const MockPairFuncInstance = GENERAL_INSTANCE;
export const MockBankFuncInstance = GENERAL_INSTANCE;
export const MockBTLYFuncInstance = GENERAL_INSTANCE;
